// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { SortTargetResult } from "igniteui-angular-spreadsheet";

export const environment = {
  production: false,
  targetPlatform:'Bloomberg',//'Bloomberg','Blacklight'
  releaseVersion:'1.2',
  landingPage:'Home', //Home,SecurityTrend,HerdRiskCalc,PeerGroup,PortfolioImport,S3MapScreener
  // BBG PROD - '.'
  //mapServiceURL:'.'
  // local - https:/localhost/service
  mapServiceURL:'http://localhost/S3.BB.Blacklight.Service',
  // Blacklight - https:/localhost/service,
  //mapServiceURL:'http://localhost/S3.BB.Blacklight.Service'
  //targetServiceURL: '.'
  targetServiceURL:'https://uatblacklight.s3partners.net/S3MapHomeServices',
  passwordMinLength: 8,
  otpExpiryMinutes: 2,
  productId: '40'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
